import { isConstTypeReference } from "typescript";

export function parseUnicode(str:string){
    var r = /\\u([\d\w]{4})/gi;
    str = str.replace(r, function (match, grp) {
        return String.fromCharCode(parseInt(grp, 16)); } );
    return str;
}
export interface userLogin{
    email:string,
    pswd:string
}

export interface userRegister extends userLogin{
    f_name:string,
    s_name:string,
    p_name:string
}

export interface authToken{
    token:string
}

export interface Activity{
    user_distance:number,
    user_accept:string,
    hour_distance:number,
    min_distance:number,
    activity_day:string,
    image?:string,
    file_name?:string,
    images:ImagesDomain[],
    act_type:ActivityType
}

export interface filesImage{
    fName:string,
    fDataBase64:string
}

export interface mainData{
    distance_length:number,
    activity_distance:number,
    count_user:number,
    amount:number
    data?:UserRateDomain[];
}

export interface ImagesDomain{
    image:string,
    file_name?:string|null,
    activity_id?:number,
    id?:number
}

export enum StoryType{
    base, date
}

export interface StoryDay{
    activity_date_list:StoryItem[],
    activity_date:string,
    weekday:string
}

export interface StoryItem extends UserProfileDomain{
    date:string,
    time:string,
    story_id:number,
    images:ImagesDomain[],
    distance_day:number,
    count_comment:number|null,
    emojis:string[]
    emojis_list:EmogiCount[]
    act_type:ActivityType
}

export interface StoryCommentDomain extends UserProfileDomain{
    message_date:string|null;
    c_id:number|null;
    a_id:number;
    message:string;
    answer:StoryCommentDomain|null
    is_edit:boolean
}

export interface UserProfileDomain{
    u_id:number;
    user_name:string;
    distance:number;
    activity_distance:string
    photo:string|null;
    data:UserProfileRateDomain[]|null
    awards:string[]|null|undefined;
    likes:number
}

export interface UserProfileRateDomain{
    date:string;
    distance:number;
    time:string;
}

export interface EmojiDomain extends UserProfileDomain{
    story_id:number;
    emoji:string;
    emoji_date:string
}

export interface EmogiCount{
    emoji:string;
    count:number
}

export interface UserRateDomain {
    user_id:number;
    user_name:string;
    distance_length:number,
    activity_distance:number,
    awards?:string|null
}

export interface NotificationDomain{
    user_name:string;
    activity_day:string;
    text:string;
    photo:string;
}

export enum ActivityType {
    RUN="RUN",//Бег
    BICYCLE="BICYCLE",//Велосипед
    SKIS="SKIS",//Лыжи
    SWIMMING="SWIMMING",//Плавание,
    WALK="WALK",//Ходьба,
    SWIMMING_185="SWIMMING_185"//Плавание 185
}

export interface CurrentActivityType{
    activityType:ActivityType
}

export interface StoryItemDomain extends UserProfileDomain{
    act_type:ActivityType
}

export function getDescriptionActivity(activity:ActivityType|null, isPersonal:boolean):string{
    var result:string="";
    switch(activity){
        case ActivityType.RUN:
            result="результат в беге, км"
            break;
        case ActivityType.SKIS:
            result="результат в лыжном спорте, км"
            break;
        case ActivityType.BICYCLE:
            result="результат в велоспорте, км"
            break;
        case ActivityType.SWIMMING:
            result="результат в плавании, м"
            break;  
        case ActivityType.WALK:
            result="результат в ходьбе, км"
            break;   
        case ActivityType.SWIMMING_185:
            result="результат в проекте \n «Плыви 185 км за СБЕР», м"
            break;             
    }
    if(isPersonal)result = result
    return result;
}

export interface VideoBannerModel{
    name:string;
    count:number
}

export interface StatisticTrainingCommonDomain {
    distance:number;
    top:StatisticsTopDomain
}

export interface StatisticsTopDomain {
    distance:number;
    activity:ActivityType;
    name:string
}

export interface StatisticTrainingTypeDomain{
    distance:number;
    count:number;
}